/* Hale theme scripts — small, dependency-free. */
(function () {
  'use strict';

  var moneyFormat = (window.HaleTheme && window.HaleTheme.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Gallery thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main]');
    main.src = thumb.getAttribute('data-src');
    main.srcset = thumb.getAttribute('data-srcset') || '';
    main.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var button = form.querySelector('[data-add-button]');

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = [];
      form.querySelectorAll('fieldset[data-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      var legendValues = form.querySelectorAll('[data-option-value]');
      legendValues.forEach(function (el, i) { el.textContent = selected[i] || ''; });
      if (!variant) {
        button.disabled = true;
        button.textContent = button.getAttribute('data-label-unavailable');
        return;
      }
      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-soldout');
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price) +
          (variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
      }
      if (variant.featured_media && variant.featured_media.preview_image) {
        var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });

    /* Add to cart without leaving the page */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      button.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: idInput.value, quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          button.textContent = button.getAttribute('data-label-added');
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
          setTimeout(function () {
            button.disabled = false;
            button.textContent = button.getAttribute('data-label-add');
          }, 2200);
        })
        .catch(function (err) {
          button.disabled = false;
          button.textContent = button.getAttribute('data-label-add');
          var msg = form.querySelector('[data-form-error]');
          if (msg) { msg.hidden = false; msg.textContent = err.message; }
        });
    });
  });

  /* Collection sort */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
